import { FC, useState, ReactNode } from 'react';
import useResizeObserver from 'use-resize-observer';
import { t } from '@transifex/native';
import { minWidthMd, minWidthSm } from '../../utils/constants';
import styles from '../../../styles/scrollbar.module.css';
import NavigationVertical from '../components/NavigationVertical';
import { useSharedState } from '../../hooks';
import { IS_MD_SCREEN, IS_SM_SCREEN } from '../../hooks/context/useSharedState';
import { TopBar } from '..';
import { useGainsightPX } from '../../../app/services/gainsight';
import {
	Layout,
	LayoutHeader,
	LayoutLeft,
	LayoutMain,
	MAIN_CONTENT_ID,
	SkipToMainContent,
} from '../../../app/shared-components';
import GitopsValidationAlert from '../components/GitopsValidationAlert';

interface Props {
	children: ReactNode;
}

export const MainLayout: FC<Props> = ({ children }) => {
	useGainsightPX();
	const [lgSize, setLgSize] = useState(true);
	const { setState: setSmScreen } = useSharedState(IS_SM_SCREEN, false);
	const { setState: setMdScreen } = useSharedState(IS_MD_SCREEN, false);

	const { ref } = useResizeObserver<HTMLDivElement>({
		onResize: ({ width }) => {
			if (width && width < minWidthMd) {
				setMdScreen(true);
				if (width && width < minWidthSm) {
					setSmScreen(true);
				} else {
					setSmScreen(false);
				}
				setLgSize(false);
			} else {
				setLgSize(true);
				setSmScreen(false);
				setMdScreen(false);
			}
		},
	});
	return (
		<div
			ref={ref}
			data-testid="main-layout"
			style={{ position: 'relative' }}
		>
			<SkipToMainContent />
			{/* @ts-ignore */}
			<Layout>
				<LayoutHeader overflow="visible">
					<nav aria-label={t('Global')}>
						<TopBar {...{ lgSize, setLgSize }} />
					</nav>
				</LayoutHeader>
				<LayoutMain disablePadding asMain={false}>
					{/* @ts-ignore */}
					<Layout width="100%" height="100%">
						{lgSize && (
							<LayoutLeft w="2xs" minWidth="2xs" inset p="5">
								<NavigationVertical />
							</LayoutLeft>
						)}
						<LayoutMain
							id={MAIN_CONTENT_ID}
							tabIndex={0}
							layerStyle="section.main"
							className={styles['custom-scrollbar']}
						>
							<GitopsValidationAlert />
							{children}
						</LayoutMain>
					</Layout>
				</LayoutMain>
			</Layout>
		</div>
	);
};
